import { createRouter, RouterProvider } from "@tanstack/react-router";
import type { TFunction } from "i18next";

import ErrorPage from "./ErrorPage";
import { routeTree } from "./routeTree.gen";

const router = createRouter({
    routeTree,
    basepath: "/",
    defaultNotFoundComponent: () => <ErrorPage statusCode="404" />,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }

    interface StaticDataRouteOption {
        titleFn?:
            | ((t: TFunction<"translation", undefined>, params: Record<string, string>) => string)
            | null;
    }
}

function App() {
    return <RouterProvider router={router} />;
}

export default App;
